import { CustomTabs } from "../../../../components";
import { TMuiOptionTabType } from "../../../../components/molecules/custom-tab/custom-tab";
import { TProject } from "../../../../models";
import { TUseFetch } from "../../../../types/TUseFetch";
import { AnalizyEquipTab } from "./analizy-equip-tab/analizy-equip-tab";
import { EquipTab } from "./equip-tab/equip-tab";

type TTabCollabs = {
    project: TProject;
    getProject: TUseFetch;
};

export const TabCollabs = ({ project, getProject }: TTabCollabs) => {
    const hableDashboard =
        project?.TimeEntries && project.TimeEntries?.length > 0;
    const tabCollabOptions: TMuiOptionTabType = [
        {
            title: "Montar Time",
            content: <EquipTab project={project} getProject={getProject} />,
        },
        {
            title: "Analisar Time",
            isDisabled: !hableDashboard,
            content: <AnalizyEquipTab project={project} />,
        },
    ];

    return <CustomTabs tabOptions={tabCollabOptions} />;
};
